export const statusTranslationKeyMap: Record<string, string> = {
  'Données client à renseigner': 'subscriptionTable:statuses.customer_data_missing',
  'Souscription web a finaliser': 'subscriptionTable:statuses.web_subscription_pending',
  'Données compteur a renseigner': 'subscriptionTable:statuses.meter_data_missing',
  'BS complet': 'subscriptionTable:statuses.complete',
  'Prêt pour la transmission': 'subscriptionTable:statuses.ready_for_transmission',
  'Erreur lors du transfert': 'subscriptionTable:statuses.transfer_error',
  'Signé avec erreur': 'subscriptionTable:statuses.signed_with_error',
  'Rétractation par le fournisseur': 'subscriptionTable:statuses.retractation_provider',
  'Rétractation par Selectra': 'subscriptionTable:statuses.retractation_selectra',
  Signé: 'subscriptionTable:statuses.signed',
  Activé: 'subscriptionTable:statuses.activated',
  Transféré: 'subscriptionTable:statuses.transferred',
}
